import type { CSSProperties } from "react";
import type { Transition } from "framer-motion";
import type { CcontainerRootMotionProps } from "../Ccontainer/Ccontainer.types";

export const TOOLTIP_VIEWPORT_PADDING_PX = 12;
export const TOOLTIP_VERTICAL_OFFSET_PX = 10;
export const TOOLTIP_BLUR_IN_DURATION_S = 0.22;
export const TOOLTIP_CONTENT_FADE_IN_DURATION_S = 0.18;
export const TOOLTIP_ENTER_EXIT_DURATION_S = 0.18;
export const TOOLTIP_EXIT_OFFSET_PX = 6;
export const TOOLTIP_PORTAL_Z_INDEX = 10001;
export const TOOLTIP_CONTAINER_PADDING = "15px";
export const TOOLTIP_CONTAINER_RADIUS = 32;
export const TOOLTIP_CONTAINER_BACKDROP_BLUR = 0;
export const TOOLTIP_CONTAINER_GAP = 4;
export const TOOLTIP_TITLE_SIZE = 16;
export const TOOLTIP_BODY_SIZE = 14;
export const TOOLTIP_TEXT_OPACITY = 0.9;
export const TOOLTIP_TEXT_GAP = 4;
export const KEY_ESCAPE = "Escape";

export const TOOLTIP_EASE_OUT = "easeOut";
export const CSS_POSITION_FIXED = "fixed";
export const CSS_DISPLAY_FLEX = "flex";
export const CSS_FLEX_DIRECTION_COLUMN = "column";
export const CSS_POINTER_EVENTS_AUTO = "auto";
export const CSS_POINTER_EVENTS_NONE = "none";
export const CSS_MAX_CONTENT = "max-content";
export const CSS_TRANSLATE_CENTER_X = "-50%";
export const CSS_TRANSLATE_NONE = "0px";
export const CSS_TRANSLATE_ABOVE_Y = "-100%";
export const CSS_BACKDROP_BLUR_NONE = "blur(0px)";
export const CSS_BACKDROP_BLUR_VISIBLE = "blur(10px)";

export const TOOLTIP_ENTER_EXIT_TRANSITION: Transition = {
  duration: TOOLTIP_ENTER_EXIT_DURATION_S,
  ease: TOOLTIP_EASE_OUT,
};

export const TOOLTIP_CONTENT_FADE_TRANSITION: Transition = {
  duration: TOOLTIP_CONTENT_FADE_IN_DURATION_S,
  delay: TOOLTIP_BLUR_IN_DURATION_S,
  ease: TOOLTIP_EASE_OUT,
};

export const TOOLTIP_CONTAINER_ROOT_MOTION: CcontainerRootMotionProps = {
  initial: {
    backdropFilter: CSS_BACKDROP_BLUR_NONE,
  },
  animate: {
    backdropFilter: CSS_BACKDROP_BLUR_VISIBLE,
  },
  transition: {
    duration: TOOLTIP_BLUR_IN_DURATION_S,
    ease: TOOLTIP_EASE_OUT,
  },
};

export const TOOLTIP_CONTAINER_STYLE: CSSProperties = {
  WebkitBackdropFilter: CSS_BACKDROP_BLUR_VISIBLE,
};

export const TOOLTIP_CONTENT_STYLE: CSSProperties = {
  pointerEvents: CSS_POINTER_EVENTS_AUTO,
};

export const TOOLTIP_TEXT_STYLE: CSSProperties = {
  display: CSS_DISPLAY_FLEX,
  flexDirection: CSS_FLEX_DIRECTION_COLUMN,
  gap: TOOLTIP_TEXT_GAP,
};
